import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, inject } from '@angular/core';

import { TOAST_MESSAGE_REF } from '@shared/components/toast-message/toast-message-tokens';
import { ToastMessageComponent } from '@shared/components/toast-message/toast-message.component';
import { ToastMessageViewModel } from '@shared/components/toast-message/toast-message.view-model';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  readonly #overlay = inject(Overlay);
  readonly #injector = inject(Injector);

  private overlayRef?: OverlayRef;

  public openToast(vm: ToastMessageViewModel): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }

    const overlayConfig = new OverlayConfig({
      hasBackdrop: false,
      positionStrategy: this.#overlay.position().global().centerHorizontally().top('16px'),
    });

    this.overlayRef = this.#overlay.create(overlayConfig);

    const portal = new ComponentPortal(ToastMessageComponent, null, this.createInjector(vm));
    this.overlayRef.attach(portal);
  }

  public dismissToast(): void {
    this.overlayRef?.dispose();
    this.overlayRef = undefined;
  }

  private createInjector(vm: ToastMessageViewModel): Injector {
    return Injector.create({
      providers: [{ provide: TOAST_MESSAGE_REF, useValue: { vm, close: () => this.overlayRef?.dispose() } }],
      parent: this.#injector,
    });
  }
}
